import { connect } from 'react-redux';
import ReturnTag from './returnTag';
import { bindActionCreators } from 'redux';
import { getDetailsBySiteId, returnTagMrf } from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
    viewDetails: state.preSalesListReducer.viewSiteDetails,
    returnTagDetails: state.preSalesListReducer.returnTagDetails
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getDetailsBySiteId,
        returnTagMrf
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ReturnTag);
